import React from 'react'

function CDTCodeTab(): React.ReactElement {
  return <div>...</div>
}

export default CDTCodeTab
